import styled from 'styled-components';

import $FadingOverflow from 'components/FadingOverflow';
import {commonPalette} from 'styles/palette';
import {borderRadius, cardShadowCss} from 'styles/vars';

export const CampaignQuestion = styled.div`
  ${cardShadowCss(false)};
  background: #fff;
  border-radius: ${p => borderRadius[p.device]}px;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const ScrollableArea = styled($FadingOverflow)`
  flex-grow: 1;

  .FadingOverlay__InnerWrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: ${p => (p.device === 'desktop' ? '32px 32px 0' : '16px 16px 0')};
  }
`;

export const Section = styled.div`
  flex-shrink: 0;
  ${p => p.stretch && 'flex-grow: 1'}
`;

export const Header = styled.header`
  font-size: ${p => (p.device === 'desktop' ? 16 : 14)}px;
  line-height: 24px;
  opacity: 0.54;
  margin: 0 0 8px;
`;

export const Heading = styled.h2`
  font-weight: normal;

  ${p =>
    p.device === 'desktop'
      ? `
        font-size: 24px;
        line-height: 32px;
        margin: 0 0 24px;
      `
      : `
        font-size: 16px;
        line-height: 24px;
        margin: 0 0 16px;
      `}
`;

export const AnswerButtons = styled.div`
  ${p =>
    p.device === 'desktop' &&
    `
      display: flex;
      min-height: 92px;
    `}
`;

export const AnswerButton = styled.button.attrs({
  type: 'button'
})`
  background: ${commonPalette.darkestGray};
  border: 0;
  color: #000;
  cursor: pointer;
  display: block;
  font-family: inherit;
  outline: 0;
  text-align: center;

  ${p =>
    p.device === 'desktop'
      ? `
        flex-basis: 0;
        flex-grow: 1;
        font-size: 14px;
        line-height: 20px;
        padding: 8px;
      `
      : `
        font-size: 12px;
        line-height: 40px;
        padding: 0 8px;
        white-space: nowrap;
        width: 100%;
      `}

  ${p =>
    p.isSelected &&
    `
      background: ${commonPalette.txBlack};
      color: #fff;
    `}

  + ${() => AnswerButton} {
    ${p => (p.device === 'desktop' ? 'margin-left: 16px' : 'margin-top: 4px')}}
  }
`;

export const Summary = styled.dl`
  margin: 0;
`;

export const SummaryItem = styled.dd`
  font-size: 12px;
  line-height: 16px;
  margin: 0 0 8px;
  opacity: 0.6;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const SummaryDetails = styled.dt`
  font-size: 14px;
  line-height: 16px;
  margin: ${p => (p.device === 'desktop' ? '0 0 8px' : '0 0 12px')};
`;

export const SummaryFootnote = styled.footer`
  font-size: 10px;
  line-height: 16px;
  opacity: 0.34;
  margin: 8px 0 0;
`;

export const Textbox = styled.input.attrs({
  type: 'text'
})`
  background: #fff;
  border: 1px solid ${commonPalette.borderGrey};
  border-radius: 3px;
  color: #000;
  display: block;
  font-family: inherit;
  font-size: 14px;
  line-height: 20px;
  outline: 0;
  padding: 10px 16px;
  width: 100%;

  &::placeholder {
    color: rgba(0, 0, 0, 0.5);
  }
`;

export const MultilineTextbox = styled(Textbox.withComponent('textarea')).attrs({
  rows: 4
})`
  resize: none;
`;

export const Footnote = styled.footer`
  font-size: 10px;
  line-height: ${p => (p.device === 'desktop' ? 14 : 16)}px;
  opacity: 0.34;
  margin: 24px 0 0;
`;

export const FooterSection = styled.div`
  padding: ${p => (p.device === 'desktop' ? '8px 32px 32px' : '8px 16px 16px')};
`;
